import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { SpinnerOverlayComponent } from '../../components/shared/spinner-overlay/spinner-overlay.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerOverlayService {
  private overlayRef: OverlayRef = undefined!;
  private overlayCounter = 0;

  constructor(private overlay: Overlay) {}

  public show(): void {
    this.overlayCounter++;
    if (this.overlayCounter > 1) return;
    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true
    });
    this.overlayRef.attach(new ComponentPortal(SpinnerOverlayComponent));
  }

  public hide(): void {
    if (this.overlayCounter > 0) {
      this.overlayCounter--;
    }
    if (this.overlayCounter === 0) {
      this.overlayRef?.detach();
      this.overlayRef = undefined!;
    }
  }

  public isShowing(): boolean {
    return this.overlayCounter > 0;
  }
}
